export default __webpack_public_path__ + "static/media/GD_Small_Icon.6312c50c.png";